import LabelLang from "component/LabelLang/label-lang";

const SurveyCard = ({ question, onRadioChange }) => {
  const onChange = (e) => {
    const optionId = e.target.value;
    onRadioChange({ questionId: question.id, optionId: optionId });
  };
  const SurveyCardRendering = () => {
    const optionsList = question.surveyQuestionOption.map(
      ({ id, title, surveyQuestionOptionTranslation }) => {
        return (
          <label className="px-3" htmlFor={id} key={id}>
            <input
              type="radio"
              id={id}
              value={id}
              name={`poll${question.id}`}
              onChange={onChange}
            />
            <LabelLang
              id="title"
              defaultValue={title}
              translations={surveyQuestionOptionTranslation}
            />
          </label>
        );
      }
    );
    return optionsList;
  };
  return (
    <div className="item-poll">
      <h6>
        <LabelLang
          id="title"
          defaultValue={question.title}
          translations={question.surveyQuestionTranslation}
        />
      </h6>
      <div className="item-poll-form" key={question.id}>
        <SurveyCardRendering />
      </div>
    </div>
  );
};
export default SurveyCard;
